import {RoleEnum} from '@pages/global/users/user-types';
import {WorkspaceResource} from '@workspaces/resources';
import {WorkspaceList, workspacesBasePath} from '@workspaces/workspaces';

const basePath = workspacesBasePath[WorkspaceList.PILOTAGE_RH];
export const resources: WorkspaceResource[] = [
  {
    name: 'config/accounts',
    list: `${basePath}/accounts`,
    edit: `${basePath}/accounts/edit/:id`,
    create: `${basePath}/accounts/create`,
    meta: {
      label: 'labels.accounts',
      prefix: 'pages.pilotage-rh.account',
      canDelete: true,
      canCreate: true,
      deleteEndpoint: 'delete-client-account',
      accessControl: {
        [RoleEnum.ROLE_ADMIN]: ['list', 'edit', 'delete', 'create'],
        [RoleEnum.ROLE_USER]: ['list', 'edit', 'delete', 'create'],
      },
    },
  },
  {
    name: 'pilotage/indicateur-tissot',
    list: `${basePath}/indicators`,
    edit: `${basePath}/indicators/edit/:id`,
    create: `${basePath}/indicators/create`,
    meta: {
      label: 'labels.indicators',
      prefix: 'pages.pilotage-rh.indicators',
      canDelete: true,
      canCreate: true,
      accessControl: {
        [RoleEnum.ROLE_ADMIN]: ['list', 'edit', 'delete', 'create'],
        [RoleEnum.ROLE_USER]: ['list', 'create'],
      },
    },
  },
  {
    name: 'config/users',
    list: `${basePath}/users`,
    edit: `${basePath}/users/edit/:id`,
    create: `${basePath}/users/create`,
    meta: {
      label: 'labels.users',
      prefix: 'pages.pilotage-rh.user',
      canDelete: true,
      canCreate: true,
      accessControl: {
        [RoleEnum.ROLE_ADMIN]: ['list', 'edit', 'delete', 'create'],
        [RoleEnum.ROLE_USER]: ['list', 'edit', 'delete', 'create'],
      },
    },
  },
];
